module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hr'), _vm._v(" "), _c('CarForSaleAdd', {
    attrs: {
      "dropDownDetails": _vm.dropDownDetails,
      "updateItem": "true"
    }
  }), _vm._v(" "), _c('hr')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-30bac8bd", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30bac8bd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CarForSaleAddPre.vue
// module id = 112
// module chunks = 0